import AbstandAbsatz from '@src/model/enums/AbstandAbsatz';
import Ausrichtung from '@src/model/enums/Ausrichtung';
import FusszeileSpaltenlayout from '@src/model/enums/FusszeileSpaltenlayout';
import KopfzeilePositionierung from '@src/model/enums/KopfzeilePositionierung';
import Layout from '@src/model/enums/Layout';
import Umrandung from '@src/model/enums/Umrandung';
import Schrifteffekt from '@src/model/enums/Schrifteffekte';
import TextAusrichtung from '@src/model/enums/TextAusrichtung';

export default {
  clientElement: {},
  clientElements: [],
  clientElementsPagination: {},
  currentClientElementId: '',

  mandantCompareElement: {},

  clientElementZwangsupdate: {},
  updateIsFinishedCounter: 0,
  revisionsArray: [],

  liveView: false,
  liveViewRendered: false,
  layoutMode: false,
  liveViewDocLayoutName: '',
  liveViewDocLayoutRevision: NaN,
  liveViewDocLayout: {
    layout: Layout.EINSPALTIGES_LAYOUT,

    ueberschriftSchriftgroesse: 10,
    textSchriftgroesse: 10,
    ueberschriftSchriftart: 'Arial',
    textSchriftart: 'Arial',

    padding: {
      top: 20,
      bottom: 20,
      right: 20,
      left: 20
    },
    pageHyphenation: false,

    abstandAbsatz: AbstandAbsatz.AUTO,
    textAusrichtung: TextAusrichtung.LINKSBUENDIG,
    ueberschriftAbstand: AbstandAbsatz.AUTO,
    abstandVorUeberschrift: 0,
    columnGap: 4,
    sectionGap: 5,

    textSchriftFarbe: '#000000',
    ueberschriftSchriftFarbe: '#000000',

    ueberschriftHintergrundFarbe: '#9D9D9D',
    ueberschriftUnterstrichFarbe: '#000000',
    ueberschriftUnterstrichStaerke: 0,
    ueberschriftAusrichtung: Ausrichtung.LINKS,
    ueberschriftSchrifteffekte: [ Schrifteffekt.FETT ],

    // Kopfzeile
    logo: '',
    breiteLogo: 100,
    platzierungLogo: 'left',
    kopfzeileText: '',
    kopfzeileTextGroesse: 12,
    kopfzeileTextFarbe: '#000000',
    kopfzeilePositionierung: KopfzeilePositionierung.ALLE_SEITEN,
    headerSpacingBottom: 0,

    // Formular
    formularHintergrundfarbe: '#000000',
    formularRandPosition: [],
    formularRandStaerke: 0,
    formularRandRadius: 0,
    formularRandFarbe: 'transparent',
    formElementSpacing: 5,

    // Tabelle
    tabelleUmrandung: [
      Umrandung.HORIZONTAL, Umrandung.AUSSEN, Umrandung.VERTIKAL 
    ],
    tabelleUmrandungStaerke: 1,
    tabelleUmrandungFarbe: '#000000',
    tabelleHintergrundFarbe: '#FFFFFF',
    tabelleKopfzeileEffekte: [ Schrifteffekt.FETT ],
    tabelleKopfzeileSchriftFarbe: '#000000',
    tabelleKopfHintergrundFarbe: '#FFFFFF',

    // Fusszeile
    fusszeileSpaltenlayout: FusszeileSpaltenlayout.EINS,
    fusszeileTexte: [],
    footerContent: [],
    fusszeileNummerierung: Ausrichtung.RECHTS,
    fusszeileTexteGroesse: 10,
    fusszeileTexteFarbe: '#000000',
    footnoteDivider: false,
    footnoteDividerWidth: 6,
    footnoteDividerColor: '#000000',
    footerSpacingTop: 0
  },

  liveViewDocFormularLayouts: {},
  selectedLiveViewFormularInputElement: {},
  selectedLiveViewSection: {},
  liveViewDocumentSettingsRevision: 0,
  liveViewDocumentSettingsLoaded: false,

  liveViewSectionLayouts: [],
  liveViewSectionSettings: {},
  liveViewSectionLayoutsChangedCounter: 0,

  aenderungsmodus: false,
  aenderungsmodusHistory: {
    order: [],
    sections: {}
  },
  aenderungsmodusHistoryUpdateCounter: 0,
  aenderungsmodusOriginClientElement: {},
  aenderungsmodusSelectedBase: {},
  aenderungsmodusSelectedHead: {}
};

export const component = 'mandantEditor/';
